<template>
  <div class="translation-links">
    <ul class="nav nav-tabs" role="tablist">
      <li class="nav-item active">
        <a
          class="nav-link active show"
          aria-selected="true"
          data-toggle="tab"
          role="tab"
          href="#10"
          @click.prevent="changeLocale('da-DK')"
          >Dansk</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          data-toggle="tab"
          role="tab"
          href="#11"
          @click.prevent="changeLocale('en-UK')"
          >English</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  methods: {
    changeLocale(locale) {
      this.$store.commit("updateContractLocale", locale);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/apps/hemmelig/components/contract/ContractLocale.vue